import { makeConfigService } from '../data/services/common/config/config-service-factory';
import { makeLogService } from '../data/services/common/log/log/log-service-factory';
import { makeVolatileLogService } from '../data/services/common/log/volatile-log/volatile-log-service-factory';
import { makeEnvironment } from '../environments/make-environment';
import { LogLevel } from '../models/common/log-level/log-level';

export async function setup() {
  const environment = makeEnvironment();
  const logService = makeLogService();
  const volatileLogSerice = makeVolatileLogService();
  logService.setLogLevel(LogLevel.INFO);
  volatileLogSerice.setLogLevel(LogLevel.INFO);

  const configService = makeConfigService();
  await configService.init();

  window.document.title =
    environment.PROJECT_NAME + ' - ' + environment.fullVersion;
}
